<template>
  <div id="app">
    <router-view />
    <cookie-consent />
  </div>
</template>

<script>
import CookieConsent from '@/components/layout/CookieConsent.vue';
import { initAnalyticsIfConsented } from '@/utils/analytics';

export default {
  name: 'App',
  components: {
    CookieConsent
  },
  created() {
    initAnalyticsIfConsented();
  }
};
</script>

<style>
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
